import { config } from "../../config/config";
import { Observable } from "rxjs";
import { utilService } from "../utils";
/**
 * Api services for notices component
 */
export const noticeService = {
  getNotices,
  getNoticeById,
  saveReadPost,
  getReadPosts,
};

function getNotices(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getNoticeById(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts + data.id, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function saveReadPost(data) {
  // console.log(data)
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.readposts, {
      method: "POST",
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function getReadPosts(data) {
  return Observable.create((observer) => {
    let url = config.api_url + config.url.readposts + data.id + "/";

    if (data.params) {
      const queryParams = new URLSearchParams(data.params).toString();
      if (queryParams) {
        url += `?${queryParams}`;
      }
    }

    fetch(url, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
